import { useEffect, useRef, useState } from 'react';

interface ICountDownCircleTimerProps {
	time: number;
	size?: number;
	strokeWidth?: number;
	onComplete?: () => void;
}

const CountDownCircleTimer = ({ time, size = 215, onComplete, strokeWidth = 39 }: ICountDownCircleTimerProps) => {
	const radius = size / 2;
	const milliseconds = time * 1000;
	const circumference = size * Math.PI;

	const [countdown, setCountdown] = useState(milliseconds);

	const seconds = (countdown / 1000).toFixed();

	const strokeDashoffset = circumference - (countdown / milliseconds) * circumference;

	const countdownRef = useRef(milliseconds);
	useEffect(() => {
		const interval = setInterval(() => {
			if (countdownRef.current > 0) {
				countdownRef.current -= 10;
				setCountdown(countdownRef.current);
			} else {
				clearInterval(interval);
				onComplete && onComplete();
			}
		}, 10);
		return () => clearInterval(interval);
	}, [onComplete]);

	return (
		<div className='flex items-center justify-center'>
			<div className='absolute flex flex-col items-center'>
				<div className='text-[88px] font-semibold pt-3'>{seconds}</div>
				<div className='text-blue-grey font-semibold pt-6'>seconds left</div>
			</div>
			<div className='-rotate-90'>
				<svg className='scale-x-100' width={size} height={size} style={{ overflow: 'visible' }}>
					<defs>
						<linearGradient id='blue-gradient' gradientTransform='rotate(115)'>
							<stop offset='0.2%' stopColor='#0F1749' />
							<stop offset='90.5%' stopColor='#6F9DDC' />
						</linearGradient>
					</defs>
					<circle
						fill='none'
						r={radius}
						cx={radius}
						cy={radius}
						stroke='url(#blue-gradient)'
						strokeWidth={strokeWidth}
						strokeLinecap={'round'}
						style={{ opacity: 0.31 }}
					/>
					<circle
						fill='none'
						r={radius}
						cx={radius}
						cy={radius}
						stroke='url(#blue-gradient)'
						strokeWidth={strokeWidth}
						strokeLinecap={'round'}
						strokeDasharray={circumference}
						strokeDashoffset={strokeDashoffset}
						style={{ opacity: 0.9 }}
					/>
				</svg>
			</div>
		</div>
	);
};

export default CountDownCircleTimer;
